/**
 * @generated SignedSource<<f2c3e401d1bac40d32526f206363a3b6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type patientAddressTooltip_Address$data = {
  readonly city: string;
  readonly country: {
    readonly code: string;
    readonly countryLookupTranslations: ReadonlyArray<{
      readonly countryIsoCode2: string;
      readonly countryName: string;
      readonly language: string;
    }>;
    readonly id: string;
  } | null;
  readonly countryCode: string;
  readonly houseNumberStreet: string;
  readonly postalCode: string;
  readonly " $fragmentType": "patientAddressTooltip_Address";
};
export type patientAddressTooltip_Address$key = {
  readonly " $data"?: patientAddressTooltip_Address$data;
  readonly " $fragmentSpreads": FragmentRefs<"patientAddressTooltip_Address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "patientAddressTooltip_Address",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CountryLookup",
      "kind": "LinkedField",
      "name": "country",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": "code",
          "args": null,
          "kind": "ScalarField",
          "name": "countryIsoCode2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CountryLookupTranslation",
          "kind": "LinkedField",
          "name": "countryLookupTranslations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryIsoCode2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "language",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "houseNumberStreet",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryCode",
      "storageKey": null
    }
  ],
  "type": "Address",
  "abstractKey": null
};

(node as any).hash = "4778fd0033c3fcad1d41af442937b9ee";

export default node;
